<template>
	<div>
		<v-btn
			v-scroll="onScroll"
			v-show="scrollUpBtnShow"
			scrollUpBtnShow
			dark
			fixed
			bottom
			right
			color="dark"
			@click="toTop"
		>
		<v-icon>mdi-arrow-up-bold-circle</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'toTop',
	data() {
		return {
			scrollUpBtnShow: false,
		}
	},
	methods: {
		onScroll(e) {
			if (typeof window === 'undefined') return
			const top = window.pageYOffset || e.target.scrollTop || 0
			this.scrollUpBtnShow = top > 20
		},
		toTop() {
			this.$vuetify.goTo(0)
		},
	},
}
</script>

<style>

</style>
